import "../scss/style.scss";
import "scroll-hint/css/scroll-hint.css";
import "./anime.js";
import { initMainSimpleBar, getPcMainScrollElement } from "./main-simplebar.js";
import "./splide_setting.js"
import "./splide-extension-auto-scroll.js"
import "./dropdown.js"
import "./top.js"

function isPcMainScroll() {
  return window.matchMedia("(min-width: 768px)").matches && $(".main").length > 0;
}

function getScrollTop() {
  if (isPcMainScroll()) {
    const el = getPcMainScrollElement();
    return el ? $(el).scrollTop() : 0;
  }
  return $(window).scrollTop();
}

$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  if (href === "#") {
    if (isPcMainScroll()) {
      const el = getPcMainScrollElement();
      if (el) $(el).animate({ scrollTop: 0 }, speed, easing);
    } else {
      $("html, body").animate({ scrollTop: 0 }, speed, easing);
    }
    return false;
  }
  const $target = $(href);
  if (!$target.length) {
    return true;
  }
  const scrollMargin = parseInt($target.css("scroll-margin-top")) || 0;
  if (isPcMainScroll()) {
    const $scroll = $(getPcMainScrollElement());
    if ($scroll.length) {
      const nextTop =
        $scroll.scrollTop() +
        $target.offset().top -
        $scroll.offset().top -
        scrollMargin;
      $scroll.animate({ scrollTop: Math.max(0, nextTop) }, speed, easing);
    }
  } else {
    const position = $target.offset().top;
    $("html, body").animate({ scrollTop: position + scrollMargin }, speed, easing);
  }
  return false;
});

function onScrollUi() {
  if (getScrollTop() > 100) {
    $(".totop").fadeIn();
  } else {
    $(".totop").fadeOut();
  }

  $(".js-fadeUp").each(function () {
    const $el = $(this);
    if (isPcMainScroll()) {
      const mainEl = $(".main")[0];
      const rect = this.getBoundingClientRect();
      const mr = mainEl.getBoundingClientRect();
      if (rect.top < mr.bottom - 40 && rect.bottom > mr.top) {
        $el.addClass("is-fadeUp");
      } else {
        $el.removeClass("is-fadeUp");
      }
    } else {
      const targetOffset = $el.offset().top;
      const windowHeight = $(window).height();
      const scrollPosition = $(window).scrollTop();
      const targetPosition = targetOffset - windowHeight;
      if (scrollPosition > targetPosition) {
        $el.addClass("is-fadeUp");
      } else {
        $el.removeClass("is-fadeUp");
      }
    }
  });
}

function bindPcMainScrollListener() {
  const el = getPcMainScrollElement();
  $(".main").off("scroll.simplebarMain");
  $(".main .simplebar-content-wrapper").off("scroll.simplebarMain");
  if (el) {
    $(el).on("scroll.simplebarMain", onScrollUi);
  }
}

$(function () {
  initMainSimpleBar(bindPcMainScrollListener);
  $(window).on("load scroll", onScrollUi);
  bindPcMainScrollListener();
});
$(document).ready(function () {
  // ハンバーガー開閉
  $('.js-nav-bt').on('click', function () {
    $(".js-nav-content, .js-nav-logo, .js-nav-bt, .header").toggleClass('is-navOn');
  });

  // リンククリック時の処理
  $('.js-nav-link').on('click', function (e) {
    const parent = $(this).closest('.header-navList__link');

    // --- SPで下層メニューを持つ場合はアコーディオンにする ---
    if (window.innerWidth <= 767 && parent.hasClass('has-sub')) {
      e.preventDefault(); // 遷移無効化
      parent.toggleClass('is-open');
      return; // メニューは閉じない
    }

    // --- それ以外（no-subリンクやPC）はメニューを閉じる ---
    $(".js-nav-content, .js-nav-logo, .js-nav-bt, .header").removeClass('is-navOn');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".cmn-slider");

  sliders.forEach((slider) => {
    const isAchievements = slider.classList.contains("topAchievements__swiper");
    const isSupportCard = slider.classList.contains("topSupportCard__swiper");

    new Swiper(slider, {
      slidesPerView: isAchievements ? "auto" : 1,
      loop: true,
      speed: 800,
      spaceBetween: isAchievements ? 20 : isSupportCard ? 0 : 24,
      autoplay: {
        delay: isSupportCard ? 5000 : 4000,
        disableOnInteraction: false,
      },

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
});

// FAQアコーディオンメニュー
$(function () {
  $(".js-accordion-title").on("click", function () {
    var $t = $(this);
    var $panel = $t.next();
    if (!$panel.length) {
      var $dt = $t.closest("dt");
      if ($dt.length) {
        $panel = $dt.next("dd");
      }
    }
    $panel.slideToggle(300);
    $t.toggleClass("close");
    var isOpen = !$t.hasClass("close");
    $t.attr("aria-expanded", isOpen);
    var $svcUnit = $t.closest(".svcFaq__unit");
    if ($svcUnit.length) {
      $svcUnit.toggleClass("svcFaq__unit--open", isOpen);
    }
  });
});
